import { isNil } from 'ramda';
import React from 'react';

import { Button, Image, InformationTooltip, UIHeading2, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';

import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import { formatNumberWithSpaces, transformNumToString, trimToDecimals } from '../../../common/utils';

import { NBSP, PERCENT, RUB } from '../../../common/constants';
import { ETestIds } from '../../constants';
import { IOfferCardProps } from '../OfferCard';
import { LabelComponent } from '../OfferCard/components/LabelComponent';
import { PskTooltipContent } from '../PskTooltipContent';

import * as styles from './styles.css';

export const OfferCardMobile: React.FC<IOfferCardProps> = ({ offer, onClick, trackClickPskTooltip }) => {
  const { offerName, iconPath, offerDescription, label, psk, rate, monthlyPayment, type } = offer;

  return (
    <div className={styles['card']} data-testid={`${ETestIds.OfferCard} ${ETestIds.OfferCard}-${type}`}>
      <div className={styles['card__heading']}>
        <div className={styles['card__title']}>
          <div>
            <UIHeading2>{offerName}</UIHeading2>
            <UIText1>{offerDescription}</UIText1>
          </div>
          <div className={styles['card__title-icon']}>
            <Image src={iconPath} borderRadius={'50%'} title={offerName} alt={offerName} preloader />
          </div>
        </div>
        <LabelComponent text={label} />
      </div>
      {!isNil(psk) && (
        <div className={styles['card__psk']}>
          <div className={styles['card__psk-tooltip']}>
            <UIText2 color={'text-secondary-default'}>Полная стоимость кредита</UIText2>
            <div onClick={e => e.stopPropagation()}>
              <InformationTooltip
                placement={'right-start'}
                content={<PskTooltipContent />}
                header={'Полная стоимость кредита'}
                onOpen={trackClickPskTooltip}
              >
                <div className={styles['card__psk-tooltip-icon']} data-testid={ETestIds.PskTooltip}>
                  <IconFunctionalInformationCircle16 color={'icon-secondary-default'} cursor="pointer" />
                </div>
              </InformationTooltip>
            </div>
          </div>
          <div>
            <UIHeading4 color={'text-secondary-default'}>
              {transformNumToString(psk.from) + '—' + transformNumToString(psk.to) + PERCENT}
            </UIHeading4>
          </div>
        </div>
      )}
      <div className={styles['card__details']}>
        <div className={styles['card__details-item']}>
          <UIText2 color={'text-secondary-default'}>Ставка</UIText2>
          <UIHeading4 color={'text-primary-default'}>
            {transformNumToString(trimToDecimals(Number(rate))) + PERCENT}
          </UIHeading4>
        </div>
        <div className={styles['card__details-item']}>
          <UIText2 color={'text-secondary-default'}>Платёж</UIText2>
          <UIHeading4 color={'text-primary-default'}>
            {'от' + NBSP + formatNumberWithSpaces(monthlyPayment) + NBSP + RUB}
          </UIHeading4>
        </div>
      </div>
      <Button size="M" theme={'fill_secondary'} onClick={onClick} fullWidth>
        Подробнее
      </Button>
    </div>
  );
};
